import React from 'react';
import { useTranslation } from 'react-i18next';

const ShippingAndReceiving = () => {
  const { t } = useTranslation();
  return (
    <div>
      <h1>{t('inventory.shipping_receiving_title')}</h1>
    </div>
  );
};

export default ShippingAndReceiving;